import { render, staticRenderFns } from "./PrintTripTask.vue?vue&type=template&id=204e9520&scoped=true&"
import script from "./PrintTripTask.vue?vue&type=script&lang=js&"
export * from "./PrintTripTask.vue?vue&type=script&lang=js&"
import style0 from "./PrintTripTask.vue?vue&type=style&index=0&id=204e9520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e9520",
  null
  
)

export default component.exports